import { Controller } from "@hotwired/stimulus"

// Copies the source input's value to the clipboard and flips the button label.
export default class extends Controller {
  static targets = ["source", "label"]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      const original = this.labelTarget.textContent
      this.labelTarget.textContent = this.labelTarget.dataset.copied || "Copié !"
      setTimeout(() => { this.labelTarget.textContent = original }, 1800)
    })
  }
}
